export const ALARM_TYPE = [
    {
        label: '非法拆除',
        value: '12'
    },
    {
        label: '离线报警',
        value: '66'
    },
    {
        label: '超时未行使',
        value: '5'
    },
]

/**
 * 预警消息模版
 */
export const ALARM_TEMPLATE_0 = "『监控运营报警』: 『${orderCity}』 『订单号${orderNumber}』「${alarmType}」 地址: ${location}, 「报警时间」: ${alarmTime} 请及时处理!";

/**
 * 超时消息模版
 */
export const ALARM_TEMPLATE_1 = "『监控运营报警』: 『${orderCity}』 『订单号${orderNumber}』「${alarmType}」 地址: ${location}, 「报警时间」: ${alarmTime} 请及时处理!";
